import { createFileRoute } from "@tanstack/react-router";
import { Globe } from "lucide-react";

import { ContentVelocityTrend } from "@/components/brand-intel/industry/content-velocity-trend";
import { DigitalShareVoice } from "@/components/brand-intel/industry/digital-share-voice";
import { IndustryStatCards } from "@/components/brand-intel/industry/industry-stats";
import { KeyIndustryShift } from "@/components/brand-intel/industry/key-industry-shift";
import { PageHeader } from "@/components/layout/heading";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/dashboard/intelligence/_layout/industry")({
  component: Industry,
});

export function Industry() {
  const session = useSession();
  const companyName = session.profile.company?.company_name;
  
  return (
    <section className="w-full space-y-6">
       <PageHeader title={
        <div className="flex items-center gap-2">
          <Globe className="size-5 text-muted-foreground" strokeWidth={2.5} />
          Industry Landscape - {companyName ? ` ${companyName}` : ""}
        </div>
      } />
      <IndustryStatCards />
      <div className="grid gap-6 lg:grid-cols-2">
        <KeyIndustryShift />
        <ContentVelocityTrend />
      </div>
      <div className="grid gap-6">
        <DigitalShareVoice />
      </div>
    </section>
  );
}
